module.exports = __webpack_public_path__ + "static/media/chart-green.17e8a24c.svg";